export default "__VITE_ASSET__ChlKd6rw__"